module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_sekundaerlogo_postale_pos.252714c8.pdf";